
export class WireCompanyLogoModel {
    url: string;

    constructor(apiModel?: WireCompanyLogoModel) {
        if (apiModel) {
            this.url = apiModel.url;
        }
    }

    toApiModel(): WireCompanyLogoModel {
        return {
            url: this.url
        } as WireCompanyLogoModel;
    }

    clone(): WireCompanyLogoModel {
        return new WireCompanyLogoModel(this.toApiModel());
    }

    equals(other: WireCompanyLogoModel): boolean {
        return this.url === other.url;
    }
}
